import Repository from '../../../../../foundation/repository/Repository';
import ApiData from '../../../../../foundation/repository/ApiData';
import ExerciseTemplate from '../aggregates/exerciseTemplate/ExerciseTemplate';

export default class ExerciseTemplateRepository extends Repository<ExerciseTemplate> {

	public getPublicList () {
		return this.getAll().filter(template => [10, 11].includes(template.getId().getValue() as number));
	}

	public mapObject (data: ApiData) {
		return new ExerciseTemplate(
			data.id<ExerciseTemplate>('id'),
			data.string('name'),
			data.string('content')
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/domain/repositories/ExerciseTemplateRepository.ts